import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { addCustomCharge } from '../order/actions';
import Form from './components/Form';
import { syncValidateData } from '../../common/validator';
import { getAll } from '../../main/barbers/selector';
import { getBarberUser, getIsRentalBarber } from '../../auth/selectors';


const FORM = 'customChargeForm';

const schema = Joi.object().keys({
  amount: Joi.number().min(1).required(),
  desc: Joi.string().optional().allow(null, ''),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: FORM,
  validate,
});

const addHandlers = withHandlers({
  charge: props => data => props.addCustomCharge(data),
});

const mapStateToProps = (state) => {
  const isRentalBarber = getIsRentalBarber(state);

  return ({
    barbers: isRentalBarber ? [getBarberUser(state)] : getAll(state),
    isUnassignedChargeAvailable: !isRentalBarber,
  });
};

const mapDispatchToProps = {
  addCustomCharge,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  addHandlers,
  form,
)(Form);
